import {Plus} from 'lucide-react'
import { useState } from 'react'

const faqs = [
  {
    q: '如何訂購這款限定香氛？',
    a: '請於訂購區選擇 The Taste Of...香氛組合或單支香氛，填寫收件資訊並完成匯款，我們將依照付款順序為您安排出貨。',
  },
  {
    q: '付款方式與金額怎麼計算？',
    a: '可選擇銀行轉帳或 7-ELEVEN 取貨付款，金額依選購組合與數量計算：The Taste Of...香氛組合 NT$ 1,880／組，單支香氛 NT$ 980／支。',
  },
  {
    q: '使用時有什麼需要注意的嗎？',
    a: '請避免陽光直射，置於陰涼乾燥處；避免直接接觸眼睛，如不慎接觸請以清水沖洗；肌膚若有不適請停止使用並諮詢醫生。',
  },
  {
    q: '訂單成立後多久會出貨？',
    a: '確認收到匯款後，我們將依訂單順序盡快安排出貨，若有特殊情況將主動與您聯繫說明。',
  },
]

function Specifications() {
  const [openIndex, setOpenIndex] = useState<number | null>(0)

  return (
    <section id="faq" className="bg-zinc-100 py-10 sm:py-20 lg:py-28">
      <div className="max-w-4xl mx-auto px-5 sm:px-6 lg:px-10">
        <div className="mb-8 sm:mb-14">
          <p className="text-xs tracking-[0.3em] text-slate-500 mb-3 sm:mb-4">FAQ</p>
          <h2 className="font-serif text-[22px] sm:text-3xl lg:text-4xl text-zinc-900">常見問題</h2>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index
            return (
              <div key={faq.q} className="bg-white border border-zinc-200 rounded-sm overflow-hidden transition-colors duration-300">
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="w-full flex items-center justify-between gap-4 text-left px-5 lg:px-6 py-3.5 min-h-12"
                >
                  <span className="text-sm lg:text-base font-medium" style={{ color: '#1A1A1A', opacity: 1 }}>{faq.q}</span>
                  <Plus
                    className="text-slate-500 flex-shrink-0"
                    size={18}
                    style={{ transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease-in-out' }}
                  />
                </button>
                <div
                  style={{
                    maxHeight: isOpen ? '500px' : '0px',
                    opacity: isOpen ? 1 : 0,
                    overflow: 'hidden',
                    transition: 'max-height 0.3s ease-in-out, opacity 0.3s ease-in-out',
                  }}
                >
                  <p className="px-5 lg:px-6 pb-4 text-sm leading-[1.6]" style={{ color: '#1A1A1A' }}>
                    {faq.a}
                  </p>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default Specifications
